module.exports = __webpack_public_path__ + "img/doubleCash.473d76f2.svg";